// src/components/Header/Header.tsx
import React, { FC, useState, useEffect } from "react";
import { IconType } from "react-icons";
import MainNav from "./MainNav";
import AnnouncementBar from "./AnnouncementBar";
import { FiZap, FiBox, FiCpu, FiStar } from "react-icons/fi";
import { useThrottle } from "hooks/useThrottle";

// Helper component for rendering icons dynamically
const Icon: FC<{ icon: IconType; className?: string }> = ({ icon, className }) => {
  const IconComp = icon as React.ElementType;
  return <IconComp className={className} />;
};

const Header: FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  const throttledHandleScroll = useThrottle(() => {
    const scrolledBeyondThreshold = window.scrollY > 50;
    if (scrolledBeyondThreshold !== isScrolled) {
      setIsScrolled(scrolledBeyondThreshold);
    }
  }, 100);

  useEffect(() => {
    window.addEventListener("scroll", throttledHandleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", throttledHandleScroll);
    };
  }, [throttledHandleScroll]);

  return (
    <div
      className={`nc-Header sticky top-0 w-full z-40 transition-all duration-300
        ${isScrolled
          ? "bg-white/90 dark:bg-[#020102] shadow-lg backdrop-blur-sm" 
          : "bg-white dark:bg-neutral-900/90"
        }
      `}
    >
      {/* AnnouncementBar is only visible when not scrolled */}
      <AnnouncementBar
        startDate="2026-04-01T00:00:00"
        endDate="2026-05-01T00:00:00"
        messages={[
          <span className="flex items-center gap-2">
            <Icon icon={FiZap} className="text-[#ff6600]" />
            Elephant Robotics Has Arrived! Explore the Future of Robotics.
          </span>,
          <span className="flex items-center gap-2">
            <Icon icon={FiCpu} className="text-[#ff6600]" />
            New: myCobot, mechArm, and Mercury Series are now in stock!
          </span>,
          <span className="flex items-center gap-2">
            <Icon icon={FiBox} className="text-[#ff6600]" />
            Get started with AI Robot Kits for Education & Research.
          </span>,
          <span className="flex items-center gap-2">
            <Icon icon={FiStar} className="text-[#ff6600]" />
            Shop Premium Robotic Arms and Accessories today.
          </span>,
        ]}
        isVisibleAtTop={!isScrolled}
      />
      <MainNav isScrolled={isScrolled} />
    </div>
  );
};

export default Header;
